import axios from "../../../services/axios";



export const checkCommandStatus = async (client, company) => {
    try {
        const { data, status } = await axios.get(`/smartmenu/command/${client.id}`, {
            params: {
                companyId: company.id,
                number: client.number,
                tax: company.service_tax,
            },
        });

        // CASO A REQUISIÇÃO RETORNE 200 MAS O STATUS DA COMANDA SEJA "FALSE"
        if (status === 200 && !data?.status) {
            return false;
        }

        return true;
        
    } catch (error) {
        console.error('ERROR - CHECK COMMAND STATUS:', error);
        return false;
    }
};